import type { ComponentProps } from 'react'

import { cn } from '@/lib/utils'

/** Multi-line sibling of {@link Input}; identical tokens, no fixed height. */
function Textarea({ className, ...props }: ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'flex min-h-20 w-full min-w-0 rounded-md border border-input bg-card px-3 py-2 text-sm',
        'text-foreground placeholder:text-muted-foreground/70 shadow-xs transition-[color,box-shadow,border-color]',
        'outline-none selection:bg-primary selection:text-primary-foreground',
        'focus-visible:border-[var(--ring)] focus-visible:ring-[3px] focus-visible:ring-[color-mix(in_oklch,var(--ring)_28%,transparent)]',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'aria-invalid:border-destructive aria-invalid:ring-[color-mix(in_oklch,var(--destructive)_25%,transparent)]',
        className,
      )}
      {...props}
    />
  )
}

export { Textarea }
